export default {
  importMarker: 'Subscription source',
  fromFamily: 'Subscribed rates',
  notFromFamily: 'Non-subscribed rates',
  title: 'Rate subscriptions',
  published: 'Published rates',
  companySearch: 'Search sharing company',
  groupSearch: 'Search group',
  search: 'Search',
  all: 'All',
  subscribed: 'Subscribed',
  unsubscribed: 'Not subscribed',
  loadFailed: 'Unable to load. Please refresh.',
  empty: 'No published rates',
  company: 'Sharing company',
  group: 'Rate group',
  carrier: 'Carrier',
  dischargePortRoute: 'Discharge port route',
  rates: 'Rate details',
  shareTime: 'Last published',
  status: 'Subscription status',
  pending: '{count} pending',
  subscriberCount: 'Subscribers',
  operations: 'Actions',
  details: 'View details',
  subscribe: 'Subscribe',
  update: 'Update now',
  cancel: 'Unsubscribe',
  autoUpdate: 'Automatic updates',
  autoHelp: 'When off, changes remain pending. You can update manually.',
  subscribers: 'Subscriber companies',
  sourceStatus: 'Published status',
  available: 'Available',
  unavailable: 'Unavailable',
  localRate: 'Local rate ID',
  syncResult: 'Sync result',
  finalPrice: 'Published price',
  subscriptionPrice: 'Subscription price',
  historyPriceMissing: 'The historical subscription price was not recorded. Check the imported rate in your local rates.',
  yes: 'Yes',
  no: 'No',
  progress: 'Synchronization results',
  result:
    '{total} items: {succeeded} succeeded, {failed} failed; {inserted} inserted, {updated} updated, {offline} offline, {skipped} unchanged, {retained} retained.',
  reason: 'Failure reason',
  noticePending: 'Result notification pending. Imported rates are already saved.',
  accepted: 'Accepted. See synchronization results.',
  cancelHelp: 'Imported rates will be retained and updates will stop. Unsubscribe from this group?',
  cancelled: 'Unsubscribed. {count} imported rates retained.',
  singleSource: 'Incomplete group details',
  lastSync: 'Last successful sync',
  noChange: 'Already up to date. Local rates were retained.',
  labelMissing: 'Name unavailable',
  subscribeHelp:
    'Sharing company: {company}. Group: {group}, currently {count} rates. Automatic updates are enabled by default and follow new rates and changes in this group. Subscribe?',
  states: {
    accepted: 'Queued',
    running: 'Processing',
    succeeded: 'Succeeded',
    partialFailed: 'Partly failed',
    failed: 'Failed',
    cancelled: 'Cancelled',
    pending: 'Pending update',
    synced: 'Synchronized',
    following: 'Following',
    sourceInactive: 'Source inactive',
    retained: 'Retained; updates stopped',
    inserted: 'Inserted',
    updated: 'Updated',
    offline: 'Offline',
    skipped: 'Unchanged'
  },
  errors: {
    noSalesRule: 'No active CargoWareX sales rule matches this rate. It cannot be imported yet.',
    supplierMissing: 'Create an active local supplier for the sharing company, then retry.',
    supplierAmbiguous:
      'Multiple local suppliers match the sharing company. Resolve duplicates, then retry.',
    dataMatchFailed:
      'Master data could not be matched uniquely. Maintain local master data, then retry.',
    snapshotInvalid: 'The published version changed. Refresh and retry.',
    groupUnavailable: 'This group has no available public rates.',
    accessDenied: 'Your current permissions do not allow this operation.',
    conflict: 'Settings or execution changed. Refresh and retry.',
    syncUnavailable: 'Synchronization failed. Review results and retry.'
  },
  fields: {
    airportId: 'Service airport',
    destinationPortId: 'Destination port',
    loadingPortId: 'Loading port',
    loadingStationId: 'Loading station',
    destinationStationId: 'Destination station',

    pol: 'Origin',
    pod: 'Destination',
    por: 'Place of receipt',
    pdl: 'Place of delivery',
    carrierId: 'Shipping line',
    airlineId: 'Airline',
    railCompanyId: 'Rail operator',
    departureAirportId: 'Departure airport',
    arrivalAirportId: 'Arrival airport',
    departureStationId: 'Departure station',
    arrivalStationId: 'Arrival station',
    dischargePortId: 'Discharge port',
    startAddress: 'Origin address',
    destinationAddress: 'Destination address',
    beginDate: 'Valid from',
    endDate: 'Valid until',
    vessel: 'Vessel',
    voyage: 'Voyage',
    etd: 'ETD',
    eta: 'ETA',
    flightNo: 'Flight number',
    railTrainNo: 'Train number',
    voyageDays: 'Transit days',
    voyageHours: 'Transit hours',
    loadMode: 'Load mode',
    serviceType: 'Service type',
    routeType: 'Route type',
    priceMethod: 'Transport method',
    billingModel: 'Billing model',
    billingMethod: 'Billing method',
    transportMode: 'Transport mode',
    remarks: 'Remarks',
    overweightRemarks: 'Overweight remarks',
    receivingInstructions: 'Receiving instructions'
  },
  dimensions: {
    billingModel: {
      FIRST_ADDITIONAL: 'First and additional weight',
      UNIT_PRICE: 'Unit price',
      WEIGHT_TIER: 'Weight tiers'
    },
    billingMethod: {
      WEIGHT: 'Weight',
      VOLUME: 'Volume',
      WEIGHT_VOLUME_MAX: 'Greater of weight and volume',
      TICKET: 'Per shipment'
    },

    loadMode: {
      EXPRESS: 'Express',
      LTL: 'LTL',
      FTL: 'FTL'
    },
    routeType: {
      DOMESTIC: 'Domestic',
      INTERNATIONAL: 'International',
      PENDING: 'Pending'
    },
    priceMethod: {
      '1': 'Direct haulage',
      '2': 'Barge',
      '3': 'Sea and rail'
    },
    serviceType: {
      express: 'Express',
      standard: 'Standard',
      economy: 'Economy',
      priority_freight: 'Priority freight',
      economy_freight: 'Economy freight',
      deferred_freight: 'Deferred freight'
    }
  }
}
